<ng-container *ngIf="showContent$ | async; else errorPage">
    <ng-container *ngIf="(isLoading$ | async) === false">
        <por-product-detail [isPublicView]="true"></por-product-detail>
    </ng-container>
</ng-container>

<ng-template #errorPage>
    <div class="asset-tag-error-page">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <h2>{{ (errorTitle$ | async) || '' | translate }}</h2>
        <p>{{ (errorMessage$ | async) || '' | translate }}</p>
        <p class="contact-guidance">{{ 'assetTagContactStore' | translate }}</p>
    </div>
</ng-template>
